export default __webpack_public_path__ + "static/media/fr2.63f315f5.webp";